/**
 * Timer model
 */

import { Action, SetupActionData } from './Action';
import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];

export class Timer {
    Name: string = "";
    TType: string = "";
    Active: boolean = false;
    Restart: boolean = false;
    TurnNumber: number = 0;
    Length: number = 0;
    LiveTimer: boolean = false;
    TimerSeconds: number = 0;
    CustomProperties: CustomProperty[] = [];
    Actions: Action[] = [];
    curtickcount: number = 0;
    ActionsUseAdvanced: boolean = false;

    cloneForDiff(): {
        TType: string;
        Active: boolean;
        TurnNumber: number;
        Length: number;
        LiveTimer: boolean;
        TimerSeconds: number;
        curtickcount: number;
        CustomProperties: any[];
        Actions: any[];
    } {
        return {
            TType: this.TType,
            Active: this.Active,
            TurnNumber: this.TurnNumber,
            Length: this.Length,
            LiveTimer: this.LiveTimer,
            TimerSeconds: this.TimerSeconds,
            curtickcount: this.curtickcount,
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
            Actions: (window as any).ArrayCloneForDiff?.(this.Actions) || this.Actions.slice(),
        };
    }
}

export function SetupTimerData(GameData: any[]): Timer {
    const TheTimer = new Timer();
    TheTimer.Name = GameData[0];
    TheTimer.TType = GameData[1];
    TheTimer.Active = GameData[2];
    TheTimer.Restart = GameData[3];
    TheTimer.TurnNumber = GameData[4];
    TheTimer.Length = GameData[5];
    TheTimer.LiveTimer = GameData[6];
    TheTimer.TimerSeconds = GameData[7];
    for (let i = 0; i < GameData[8].length; i++) {
        TheTimer.CustomProperties.push(SetupCustomPropertyData(GameData[8][i]));
    }
    for (let j = 0; j < GameData[9].length; j++) {
        TheTimer.Actions.push(SetupActionData(GameData[9][j]));
    }
    TheTimer.ActionsUseAdvanced = Boolean(GameData[10]);
    return TheTimer;
}
